import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import Client from "../../../utils/client";

function Alerts() {
    const [alerts, setAlerts] = useState([]);
    const [error, setError] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const itemsPerView = 3; // Number of alerts to show per slide
    const limit = 10;
    const offset = 0;

    useEffect(() => {
        async function fetchAlerts() {
            try {
                const response = await Client.get(`/alerts?limit=`+ limit+`&offset=` + offset);
                let fetchedAlerts = response.data;

                // Sort alerts by pubDate (most recent first)
                fetchedAlerts = fetchedAlerts.sort((a, b) => new Date(a.pubDate) - new Date(b.pubDate));

                setAlerts(fetchedAlerts);
            } catch (err) {
                setError("فشل في جلب التنبيهات");
                toast.error("فشل في جلب التنبيهات");
            }
        }

        fetchAlerts();
    }, []);

    useEffect(() => {
        if (alerts.length > 0) {
            const interval = setInterval(() => {
                handleNext();
            }, 7000); // Change slides every 7 seconds

            return () => clearInterval(interval);
        }
    }, [alerts]);

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? alerts.length - itemsPerView : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex >= alerts.length - itemsPerView ? 0 : prevIndex + 1
        );
    };

    if (error) return <div>{error}</div>;

    return (
        <div className="relative w-full mx-auto rtl px-4 sm:px-10">
            <h2 className="text-center my-5 font-medium text-lg">
                تحذيرات الطقس في &nbsp;
                <span className="font-bold text-xl">
                    السودان
                </span>
            </h2>
            {alerts.length === 0 ? (
                <p>لا توجد تنبيهات متاحة</p>
            ) : (
                <div className="relative px-10">
                    <div className="overflow-hidden">
                        <div
                            className="flex transition-transform duration-500"
                            style={{  transform: `translateX(${(currentIndex - (alerts.length - itemsPerView)) * (100 / itemsPerView)}%)` }}
                        >
                            {alerts.map((alert) => (
                                <Link
                                    to={`/home/alerts/${alert.id}`}
                                    key={alert.id}
                                    className="flex-none w-full md:w-1/3 px-2"
                                >
                                    <div className="w-full h-[450px] bg-slate-50 rounded-lg overflow-hidden border duration-300 ease-in-out transform transition-all group hover:scale-[1.03]">
                                        <div className="relative w-full h-[200px]">
                                            <img
                                                src="https://assets.weather-forecast.com/maps/static/Sudan.cloud.6.cc23.jpg"
                                                alt={alert.title}
                                                className="object-cover group-hover:scale-110 duration-300 ease-in-out transform transition-all max-h-[200px] w-full"
                                            />
                                        </div>
                                        <div className="p-3 h-[250px] flex flex-col justify-between">
                                            <div>
                                                <p className="text-lg font-semibold tracking-wider line-clamp-2">
                                                    {alert.title.length > 40 ? '...' + alert.title.slice(0, 40) : alert.title}
                                                </p>
                                                <p className="text-sm my-2 indent-2 text-slate-500 line-clamp-5">
                                                    {alert.description.length > 120
                                                        ? '...' + alert.description.slice(0, 100)
                                                        : alert.description}
                                                </p>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <div className="flex gap-[0.5px] text-sm text-slate-500">
                                                    <p>
                                                        {new Date(alert.pubDate).toLocaleDateString()}
                                                    </p>
                                                </div>
                                                <button className="bg-primary text-white py-1.5 px-3 rounded-lg">
                                                    رؤية التنبيه
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>

                    <button
                        onClick={handleNext}
                        className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-primary text-white p-2 w-8 h-8 flex text-center items-center justify-center rounded-full shadow-lg hover:bg-gray-600"
                    >
                        &#9664;
                    </button>
                    <button
                        onClick={handlePrev}
                        className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-primary text-white p-2 w-8 h-8 flex text-center items-center justify-center rounded-full shadow-lg hover:bg-gray-600"
                    >
                        &#9654;
                    </button>
                </div>
            )}
        </div>
    );
}

export default Alerts;
